import React, { useMemo } from "react";
import PropTypes from "prop-types";
import "../css/cards.css";

const EngagementDistributionCard = ({ distribution }) => {
  const safeDistribution = Array.isArray(distribution) ? distribution : [];
  const total = useMemo(
    () =>
      safeDistribution.reduce(
        (sum, segment) => sum + Number(segment?.count || 0),
        0
      ),
    [safeDistribution]
  );

  if (!safeDistribution.length || total === 0) {
    return (
      <div className="chart-card">
        <h3 className="chart-title">Engagement Segments</h3>
        <p className="chart-description">
          We classify each student based on their last seven days of activity.
        </p>
        <p className="dashboard-modal-empty compact">
          No engagement distribution is available yet.
        </p>
      </div>
    );
  }

  return (
    <div className="chart-card">
      <h3 className="chart-title">Engagement Segments</h3>
      <p className="chart-description">
        Based on the last seven days of activity. High means 20+ questions,
        Medium 5-19, Low 1-4, and Inactive otherwise.
      </p>
      <ul className="engagement-distribution-list">
        {safeDistribution.map((segment) => {
          const value = Number(segment?.count || 0);
          const percent = Math.round((value / total) * 100);
          return (
            <li key={segment.level}>
              <div>
                <strong>{segment.level}</strong>
                <span>{value} students</span>
              </div>
              <div className="distribution-progress">
                <div
                  className="distribution-progress-fill"
                  style={{
                    width: `${percent}%`,
                    background: segment.color || "#6366f1",
                  }}
                />
              </div>
              <span className="distribution-percent">{percent}%</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

EngagementDistributionCard.propTypes = {
  distribution: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.string,
      count: PropTypes.number,
      color: PropTypes.string,
    })
  ),
};

export default EngagementDistributionCard;
